import React from 'react';
import PropTypes from 'prop-types';
import HelpButton from '../../atoms/helpButton/helpButton';
import './formShowText.scss';

const FormShowText = (props) => {
  const {
    label,
    helpText,
    value,
    hidden,
    classCss,
    classCssLabel
  } = props;

  return (
    <div className="row">
      {!hidden && <div className="col">
        {helpText !== ''
          && <HelpButton>{helpText}</HelpButton>}
         <span className={classCssLabel}> {label}</span>
        :
        {' '}
        <span className={classCss?classCss:""} >{value !== null
          && value.toString()}</span>
      </div>}
    </div>
  );
};

FormShowText.propTypes = {
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  /**
   * Input help text
   */
  helpText: PropTypes.string,
};

FormShowText.defaultProps = {
  label: '',
  helpText: '',
  value: '',
};

export default FormShowText;
